<template>
    <el-dialog
        ref="inTransitEditDialog"
        title="在途编辑"
        width="45%"
        class="inTransit-edit-dialog"
        :append-to-body="true"
        :visible="dialogVisible"
        :close-on-click-modal="false"
        :before-close="handleClose"
    >
        <el-form
            :model="formData"
            :rules="rules"
            ref="form"
            label-width="100px"
        >
            <el-row>
                <el-col :span="10">
                    <el-form-item label="承运商：" prop="carrierName">
                        <otpAdvance
                            :disabled="true"
                            :formData="formData"
                            :prop="'carrierName'"
                            :mValue="formData.carrierName"
                            :params="config.controlSupplier"
                            @getAdvanceValue="getCarrierValue"
                        >
                        </otpAdvance>
                    </el-form-item>
                </el-col>
                <el-col :span="10" :offset="2">
                    <el-form-item label="采购渠道：" prop="procurementChannel">
                        <selects
                            filterable
                            :disabled="true"
                            :prop="'procurementChannel'"
                            :mValue="formData.procurementChannel"
                            :optionNum="'OTP_TMS_PROCUREMENT_CHANNEL'"
                            @getSelectValue="getSelectValue"
                        ></selects>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="10">
                    <el-form-item label="车牌：" prop="vehicleCard">
                        <otpAdvance
                            :formData="formData"
                            :prop="'vehicleCard'"
                            :mValue="formData.vehicleCard"
                            :params="config.controlVehicleCard"
                            @getAdvanceValue="getVehicleCardValue"
                        ></otpAdvance>
                    </el-form-item>
                </el-col>
                <el-col :span="10" :offset="2">
                    <el-form-item label="车型：" prop="equipmentName">
                        <el-input
                            :disabled="true"
                            v-model="formData.equipmentName"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="10">
                    <el-form-item label="司机姓名：" prop="driver">
                        <otpAdvance
                            :formData="formData"
                            :mValue="formData.driver"
                            :prop="'driver'"
                            :params="config.controlDriver"
                            @getAdvanceValue="getDriverValue"
                        ></otpAdvance>
                    </el-form-item>
                </el-col>
                <el-col :span="10" :offset="2">
                    <el-form-item label="司机联系电话：" prop="driverContactWay">
                        <el-input
                            clearable
                            :disabled="true"
                            v-model.trim="formData.driverContactWay"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="handleSave" :loading="loading">保 存</el-button>
        </span>
    </el-dialog>
</template>
<script>
import config from './config.js';
import selects from '@/components/lots/otpSelect';
import otpAdvance from '@/components/lots/otpAdvance';
import { updateDispatchOntheway } from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';

export default {
    name: 'dispatchOrder',
    components: { selects, otpAdvance },
    props: {
        componentsData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            config,
            loading: false,
            dialogVisible: true,
            formData: {
                carrierName: '',
                carrierCode: '',
                procurementChannel: '',
                vehicleCard: '',
                equipmentType: '',
                equipmentName: '',
                driver: '',
                driverNo: '',
                driverIdentity: '',
                driverContactWay: ''
            },
            rules: {
                vehicleCard: [ { required: true, message: '请选择车牌', trigger: ['blur'] } ],
                driver: [ { required: true, message: '请选择司机', trigger: ['blur'] } ]
            }
        };
    },
    methods: {
        initDialogContent () {
            const { carrierName, carrierCode, procurementChannel, vehicleCard, equipmentType, equipmentName, driver, driverNo, driverIdentity, driverContactWay } = this.componentsData;
            this.formData = { carrierName, carrierCode, procurementChannel, vehicleCard, equipmentType, equipmentName, driver, driverNo, driverIdentity, driverContactWay };
        },
        getSelectValue (data) {
            this.formData = {
                ...this.formatData,
                ...data
            };
        },
        getCarrierValue (data) {
            this.formData.carrierName = data.carrierName;
            this.formData.carrierCode = data.carrierCode;
        },
        getDriverValue (data) {
            this.formData.driver = data.driver;
            this.formData.driverNo = data.driverNo;
            this.formData.driverIdentity = data.driverIdentity;
            this.formData.driverContactWay = data.driverContactWay;
        },
        getVehicleCardValue (data) {
            this.formData.vehicleCard = data.vehicleCard;
            this.formData.equipmentType = data.equipmentType;
            this.formData.equipmentName = data.equipmentName;
        },
        handleClose () {
            this.dialogVisible = false;
            this.$emit('components-close');
        },
        handleSave () {
            const { driver, driverNo, driverIdentity, driverContactWay, vehicleCard, equipmentType, equipmentName } = this.formData;
            const param = { driver, driverNo, driverIdentity, driverContactWay, vehicleCard, equipmentType, equipmentName };
            param.dispatchNo = this.componentsData.dispatchNo;
            updateDispatchOntheway(param).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('保存成功');
                    this.$emit('components-close');
                }
            });
        }
    },
    mounted () {
        this.initDialogContent();
    }

};
</script>

<style scoped lang="less">
</style>
